/* eslint-disable */
export default {
  noRecords: 'Nenhum registro recente encontrado.',
  inBound: 'Entrada',
  outBound: 'Saída',
  missed: 'Chamada perdida',
} as const;

// @key: @#@"noRecords"@#@ @source: @#@"No recent records found."@#@
// @key: @#@"inBound"@#@ @source: @#@"Inbound"@#@
// @key: @#@"outBound"@#@ @source: @#@"Outbound"@#@
// @key: @#@"missed"@#@ @source: @#@"Missed Call"@#@
